import { api, LightningElement } from "lwc";

import { trackUserActivity } from "@devforce/th-components/modules/common/track/track";

export default class extends LightningElement {
  @api primaryCtaHref: string | null = null;
  @api primaryCtaTarget: string | null = null;
  @api primaryCtaTitle: string | null = null;
  @api secondaryCtaHref: string | null = null;
  @api secondaryCtaTarget: string | null = null;
  @api secondaryCtaTitle: string | null = null;
  @api imgAlt: string | null = null;
  @api imgSrc: string | null = null;
  @api description: string | null = null;
  @api title: string = "";
  @api background: "white" | "dark" | "light" = "white";

  private get promoClassName() {
    return `promo promo--${this.background}`;
  }

  private get handlePrimaryCtaClick() {
    return (e: MouseEvent) => {
      e.stopPropagation();
      this.handleCtaClick("primary", this.primaryCtaTitle!);
    };
  }

  private get handleSecondaryCtaClick() {
    return (e: MouseEvent) => {
      e.stopPropagation();
      this.handleCtaClick("secondary", this.secondaryCtaTitle!);
    };
  }

  handleCtaClick(ctaType: "primary" | "secondary", label: string) {
    trackUserActivity(this, "cta_clicked", {
      ctaType,
      label,
      pageLocation: "tm-promo-c",
    });
  }
}
